import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import { showToast } from '../../core/redux/toast/slice';
import { FooterButton } from 'Core/components';
import { selectMachineSafetyChecklistData } from './store/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSafetyChecklist, fetchMachineSafetyChecklistRecords } from './store/slice';
import { addMachineSafetyChecklist } from './store/slice';
import { ACTION_MODE } from '../../core/constants/constants';
import { Trash2 } from 'react-feather';
import Swal from 'sweetalert2';
const initData = {
  id: 0,
  date: new Date().toISOString(),
  itemNumber: 1,
  question: '',
  status: '',
  comments: '',
};

// const machineSafetyChecklistData = {
//   id: 0,
//   date: new Date().toISOString(),
//   itemNumber: 1,
//   question: '',
//   status: '',
//   comments: '',
// };

const ignoreKeys = ['comments', 'itemNumber', 'date', 'id'];

const SafetyChecklist = ({ data, machineId, onCloseModal, safetyActionRecord }) => {
  // const [formData, setFormData] = useState([]);
  const dispatch = useDispatch();
  const safetyData = useSelector(selectMachineSafetyChecklistData);
  const isEditMode = true;
  const [isEditable, setIsEditable] = useState(isEditMode);

  const [safetyChecklistForms, setSafetyChecklistForms] = useState([
    { ...initData, machineId: machineId },
  ]);

  const lastChecklistRef = useRef(null);

  const updateSafetyField = (index, fieldName, value) => {
    const updated = [...safetyChecklistForms];
    const updatedItem = { ...updated[index] };
    updatedItem[fieldName] = value;
    updatedItem['isDirty'] = true;
    updated[index] = updatedItem;
    setSafetyChecklistForms(updated);
  };

  useEffect(() => {
    if (safetyActionRecord && safetyActionRecord?.mode) {
      if (safetyActionRecord.mode == ACTION_MODE.VIEW) {
        setIsEditable(false);
      }
    }
  }, [safetyActionRecord]);

  useEffect(() => {
    dispatch(fetchMachineSafetyChecklistRecords(machineId));
  }, []);

  useEffect(() => {
    if (safetyData.length == 0) {
      setSafetyChecklistForms([{ ...initData, machineId: machineId }]);
    }

    if (safetyData.length > 0) {
      setSafetyChecklistForms(safetyData);
    }
  }, [safetyData]);

  const handleAddSafetyChecklistForm = async () => {
    const newFile = {
      id: 0,
      question: '',
      status: '',
      comments: '',
      machineId: machineId,
      date: new Date().toISOString(),
    };

    const newFiles = [...safetyChecklistForms, newFile];
    setSafetyChecklistForms(newFiles);
    setTimeout(() => {
      if (lastChecklistRef.current) {
        lastChecklistRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });
  if (result.isConfirmed) {
    const response = await dispatch(deleteSafetyChecklist(id));

    if (response.meta.requestStatus === 'fulfilled') {
      setSafetyChecklistForms(prevForms => prevForms.filter(item => item.id !== id));
    } else {
      dispatch(
        showToast({
          message: 'Failed to delete. Try again!',
          type: 'danger',
        })
      );
    }
  }
};

  const valid = payload => {
    if (
      !payload ||
      Object.keys(payload).some(key => {
        return (
          !ignoreKeys.includes(key) &&
          (payload[key] === undefined || payload[key] === null || payload[key] === '')
        );
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        })
      );
      return false;
    }
    return true;
  };  

  const handleClose = () => {
    onCloseModal();
  };

  const onSave = () => {
    for (const checkListItem of safetyChecklistForms.filter(file => file.isDirty)) {
      const payload = {
        id: checkListItem.id,
        question: checkListItem.question,
        status: checkListItem.status,
        comments: checkListItem.comments,
        machineId: checkListItem.machineId,
        date: checkListItem.date,
        userId: localStorage.getItem('UserId'),
      };
      if (valid(payload)) {
        if (isEditMode) {
          dispatch(addMachineSafetyChecklist(payload));
        } else {
          dispatch(addMachineSafetyChecklist(payload));
        }
      }
    }
  };

  return (
    <>
      <div className="mb-3">
        <button className="btn btn-info me-2 " onClick={handleAddSafetyChecklistForm}>
          {' '}
          + Add Safety Check Item{' '}
        </button>
      </div>
      <div>
        {safetyChecklistForms.map((safetyCheckItem, index) => (
          <div
            className="row border"
            key={index}
            ref={index === safetyChecklistForms.length - 1 ? lastChecklistRef : null}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-3 mt-3">Safety Check Item #{index + 1}</h5>
              <button className="btn btn-danger" onClick={()=>handleDelete(safetyCheckItem.id)}>
                {' '}
                <Trash2 size={16} />
              </button>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Task/Question <span className="text-danger">*</span>
                </label>
                <textarea
                  rows={5}
                  cols={5}
                  className="form-control"
                  placeholder="Enter the safety check task or question"
                  defaultValue={''}
                  value={safetyCheckItem.question}
                  onChange={e => updateSafetyField(index, 'question', e.target.value)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>
                    Status <span className="text-danger">*</span>
                  </label>

                  <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic radio toggle button group"
                  >
                    <input
                      type="radio"
                      className="btn-check"
                      id={`btnradioYes${index}`}
                      name={`btnradioStatus${index}`}
                      checked={safetyCheckItem.status === true}
                      value="Yes"
                      onChange={e => updateSafetyField(index, 'status', true)}
                    />
                    <label className="btn btn-outline-primary" htmlFor={`btnradioYes${index}`}>
                      Yes
                    </label>
                    <input
                      type="radio"
                      className="btn-check"
                      id={`btnradioNo${index}`}
                      name={`btnradioStatus${index}`}
                      checked={safetyCheckItem.status === false}
                      value="No"
                      onChange={e => updateSafetyField(index, 'status', false)}
                    />
                    <label className="btn btn-outline-primary" htmlFor={`btnradioNo${index}`}>
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="input-blocks">
                <label>
                  Comments <span className="text-danger">*</span>
                </label>
                <textarea
                  rows={5}
                  cols={5}
                  className="form-control"
                  placeholder="Enter any comments or observations"
                  defaultValue={''}
                  value={safetyCheckItem.comments}
                  onChange={e => updateSafetyField(index, 'comments', e.target.value)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row mt-2">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton saveText="Save Safety Checklist" onSave={onSave} onCancel={handleClose} />
        </div>
      </div>
    </>
  );
};

SafetyChecklist.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape(CustomPropTypes.machines),
  onChanges: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

export default SafetyChecklist;
